import { LocalNotifications } from "@capacitor/local-notifications";

export default {
  state: {
    beaconRegion: null,
  },

  mutations: {
    setBeaconRegion(state, beaconRegion) {
      state.beaconRegion = beaconRegion;
    },
  },

  actions: {
    async searchBeacon({ commit, dispatch }, payload) {
      const beaconRegion =
        new window.cordova.plugins.locationManager.BeaconRegion(
          payload?.beacon?.identifier,
          payload?.beacon?.uuid,
          payload?.beacon?.major
        );

      commit("setBeaconRegion", payload.beacon);

      const delegate = new window.cordova.plugins.locationManager.Delegate();

      delegate.didRangeBeaconsInRegion = async (pluginResult) => {
        window.cordova.plugins.locationManager.appendToDeviceLog(
          "Beacons in range: " + JSON.stringify(pluginResult?.beacons)
        );
        if (pluginResult.beacons.length > 0) {
          await LocalNotifications.schedule({
            notifications: [
              {
                title: `${payload?.poi?.name}`,
                body: `Πλησιάζετε στο σημείο ${payload?.poi?.name}`,
                id: 1,
                schedule: { at: new Date(Date.now() + 100) },
                attachments: null,
                actionTypeId: "",
                extra: null,
              },
            ],
          });

          await dispatch("stopSearching");
        }
      };

      window.cordova.plugins.locationManager.setDelegate(delegate);

      // required in iOS 8+
      window.cordova.plugins.locationManager.requestWhenInUseAuthorization();
      // or window.cordova.plugins.locationManager.requestAlwaysAuthorization()

      window.cordova.plugins.locationManager
        .startRangingBeaconsInRegion(beaconRegion)
        .fail(function (e) {
          console.error(e);
        })
        .done();
    },

    async stopSearching({ commit, state }) {
      if (state.beaconRegion == null) return;

      const beaconRegion =
        new window.cordova.plugins.locationManager.BeaconRegion(
          state.beaconRegion?.identifier,
          state.beaconRegion?.uuid,
          state.beaconRegion?.major
        );

      window.cordova.plugins.locationManager
        .stopRangingBeaconsInRegion(beaconRegion)
        .fail(function (e) {
          console.error(e);
        })
        .done();

      commit("setBeaconRegion", null);
    },
  },
};
